import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
let searchData= {
  ShipName: "",
  PageNumber: 1,
  PageSize: 25,
};

export const getPODetails = (poId) => {
  let url = `${API.PODetail}?poId=${poId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPODetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPODetailsFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPODetail = (poId, taskType) => {
  let url = `${API.PODetail}?poId=${poId}&TaskType=${taskType}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPODetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPODetailsFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPOLineItems = (poId, taskType) => {
  let url = `${API.LineItems}?PoId=${poId}&TaskType=${taskType}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPOLineItemsSuccess",
          data: response.data,
        });
        dispatch({
          type: "noPoLineItems",
          data: true,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPOLineItemsFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPOLineItem = (poId) => {
  let url = `${API.LineItems}?PoId=${poId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPOLineItemsSuccess",
          data: response.data,
        });
        dispatch({
          type: "noPoLineItems",
          data: true,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPOLineItemsFailure",
          error: "ERROR",
        });
      });
  };
};

export const UpdatePOConfirmation = (data) => {
  let url = `${API.PoConfirmation}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "POConfirmationSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "POConfirmationFailure",
          error: "ERROR",
        });
      });
  };
};

export const getCollectMDLineItems = (poId) => {
  let url = `${API.CollectMDLineItems}?POId=${poId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCollectMDLineItemsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCollectMDLineItemsFailure",
          error: "ERROR",
        });
      });
  };
};

export const UpdatePCHM = (data, poid) => {
  let url = `${API.PCHM}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Updated Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch(getCollectMDLineItems(poid));
        dispatch({
          type: "PCHMSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PCHMFailure",
          error: "ERROR",
        });
      });
  };
};

//Po Sync Exception

export const getPoSyncExceptionError = (item) => {
  let url = `${API.POSyncException}?ShipName=${item.ShipName}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPoSyncErrorListSuccess",
          data:response.data,
          /*  {
            pagination: {
              totalcount: 5,
              pageSize: 25,
              currentPage: 1,
              totalPages: 1,
              hasNext: true,
              hasPrevious: false,
            },
            data: [
              {
                shipId: 548,
                ourShipName: "synergy5",
                clientShipName: "client7-synergy",
                errorPoPullDate: "2022-05-27T17:17:19.493",
                type: "error",
                errorStatus: "updated",
                infoStatus: "",
                poNumber: "0",
                infoPoPullDate: "",
                infoShipName: "",
              },
              {
                shipId: 549,
                ourShipName: "test synergy",
                clientShipName: "synergy",
                errorPoPullDate: "2022-07-27T17:17:19.493",
                type: "error",
                errorStatus: "closed",
                infoStatus: "",
                poNumber: "0",
                infoPoPullDate: "",
                infoShipName: "",
              },
              {
                shipId: 661,
                poNumber: 131357,
                infoShipName: "MARINE GUIDE PTE LTD",
                infoPoPullDate: "2022-08-01T14:45:32.15",
                ourShipName: "",
                clientShipName: "",
                errorPoPullDate: "",
                type: "info",
                errorStatus: "",
                infoStatus: "closed",
              },
              {
                shipId: 660,
                ourShipName: "",
                clientShipName: "",
                errorPoPullDate: "",
                type: "info",
                errorStatus: "",
                infoStatus: "updated",
                poNumber: "56789",
                infoPoPullDate: "2022-05-24T09:37:39.233",
                infoShipName: "testing ship",
              },
              {
                shipId: 660,
                ourShipName: "synergy",
                clientShipName: "client-synergy",
                errorPoPullDate: "2022-04-27T17:17:19.493",
                type: "error",
                errorStatus: "pending",
                infoStatus: "",
                poNumber: "0",
                infoPoPullDate: "",
                infoShipName: "",
              },
            ],
          }, */
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPoSyncErrorListFailure",
          error: "ERROR",
        });
      });
  };
};
export const putPoSyncExceptionErrorList = (data) => {
      let url = `${API.POSyncException}`;
      return dispatch => {
          axios.put(url, data)
              .then((response) => {
                if(response.data==="Succesfully Updated"){
                  dispatch(getPoSyncExceptionError(searchData));
                  toast.success("Updated Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  dispatch({
                      type: "updatePOSyncExceptionInfoSuccess",
                      data: response.data,
                  })
                }
              })
              .catch((error) => {
                  dispatch({
                      type: "updatePOSyncExceptionInfoFailure",
                      error: "ERROR"
                  })
              })
      }
  }